(()=>{'use strict';
const root=window.Shopify?.routes?.root||'/',addonHandles=new Set(['flocage-personnalise','patch-officiel']);
let busy=false,again=false,timer,lastEligibleCount=null,quantityBusy=false;
const quantitySelector='#moonbundle-cart-drawer .moonbundle-quantity-input';

const eligible=item=>!addonHandles.has(item.handle);
const offerTitle=allocation=>String(allocation?.discount_application?.title||allocation?.title||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
const isOfferAllocation=a=>offerTitle(a).includes('2 achetes = 1 offert')||offerTitle(a).includes('2 achetes=1 offert');

function giftInfo(item){
 const allocations=(item.line_level_discount_allocations||[]).filter(isOfferAllocation);
 const promo=allocations.reduce((n,a)=>n+(Number(a.amount)||0),0);
 const original=Number(item.original_line_price ?? (item.original_price ?? item.price ?? 0)*item.quantity)||0;
 const final=Number(item.final_line_price ?? Math.max(0,original-promo))||0;
 return {promo,isGift:promo>0&&(final<=1||promo>=Math.max(0,original-1))};
}

function syncGiftRow(row,details,item){
 if(!row||!details)return false;
 const gift=eligible(item)&&giftInfo(item).isGift;
 row.classList.toggle('fd-gift-line',gift);
 let badge=details.querySelector('.fd-gift-badge');
 details.querySelector('.fd-gift-note')?.remove();
 if(gift){
  if(!badge){badge=document.createElement('span');badge.className='fd-gift-badge';details.prepend(badge);}
  if(badge.textContent!=='Offert')badge.textContent='Offert';
 }else badge?.remove();
 return gift;
}

function renderProgress(targets,paidQty,giftQty){
 const completed=Math.max(0,giftQty),extraPaid=Math.max(0,paidQty-(completed*2));
 let step=0,title='2 achetés = 1 offert',state='0 / 2',hint='Ajoute 2 maillots : le 3e passe à 0 € automatiquement.';
 if(completed>0&&extraPaid===0){
  step=3;title=completed>1?completed+' maillots offerts':completed+' maillot offert';state='Appliqué';
  hint='Offre automatique · le maillot à 0 € est indiqué “Offert”.';
 }else if(extraPaid>=2){
  step=2;title='Ton maillot offert est prêt';state='Débloqué';
  hint='Ajoute ton 3e maillot : il passe à 0 € automatiquement.';
 }else if(extraPaid===1){
  step=1;title=completed>0?'Prochain offert : encore 1 achat':'Encore 1 achat';state='1 / 2';
  hint='2 achetés = 1 offert · l’offre recommence à chaque trio.';
 }else if(completed>0){
  step=0;title=completed+' offert'+(completed>1?'s':'')+' · prochain trio';state='0 / 2';
  hint='Ajoute 2 nouveaux maillots pour débloquer le prochain offert.';
 }
 const signature=[paidQty,giftQty,step,title,state].join('|');
 for(const el of targets){
  if(el.dataset.trioState===signature)continue;
  el.dataset.trioState=signature;el.setAttribute('role','status');el.setAttribute('aria-live','polite');el.replaceChildren();
  const head=document.createElement('div');head.className='fd-trio-head';
  const strong=document.createElement('strong');strong.className='fd-trio-progress-title';strong.textContent=title;
  const badge=document.createElement('span');badge.className='fd-trio-state';badge.textContent=state;
  head.append(strong,badge);
  const bars=document.createElement('div');bars.className='fd-trio-bars';
  for(let i=1;i<=3;i++){const bar=document.createElement('span');bar.className='fd-trio-bar'+(i===3?' is-gift':'')+(step>=i?' is-on':'');bars.append(bar);}
  const sub=document.createElement('span');sub.className='fd-trio-hint';sub.textContent=hint;
  el.append(head,bars,sub);
  el.classList.remove('fdca-progress-pop');void el.offsetWidth;el.classList.add('fdca-progress-pop');
 }
}

function quantityNotice(message,error=false){
 const drawer=document.getElementById('moonbundle-cart-drawer');if(!drawer)return;
 let note=drawer.querySelector('.fd-quantity-status');
 if(!note){note=document.createElement('p');note.className='fd-quantity-status';note.setAttribute('role','status');note.setAttribute('aria-live','polite');(drawer.querySelector('.fd-moon-progress')||drawer).append(note);}
 note.classList.toggle('is-error',error);note.textContent=message;
}
function syncQuantities(cart){
 document.querySelectorAll(quantitySelector).forEach(input=>{
  const item=cart.items.find(line=>line.key===input.dataset.itemKey);if(!item)return;
  input.setAttribute('aria-label','Quantité — '+item.product_title);input.inputMode='numeric';input.step='1';
  input.dataset.fdActualQuantity=String(item.quantity);
  if(!input.dataset.fdQuantityDirty&&!quantityBusy)input.value=String(item.quantity);
 });
}
async function commitQuantity(input){
 if(quantityBusy||!input.isConnected)return;
 const raw=input.value.trim(),quantity=Number(raw),previous=input.dataset.fdActualQuantity;
 if(!raw||!Number.isSafeInteger(quantity)||quantity<1){
  input.value=previous||'1';delete input.dataset.fdQuantityDirty;
  quantityNotice('Saisis un nombre entier à partir de 1. Pour retirer un article, utilise la corbeille.',true);return;
 }
 delete input.dataset.fdQuantityDirty;if(previous===String(quantity))return;
 const key=input.dataset.itemKey;if(!key)return;
 quantityBusy=true;const drawer=input.closest('#moonbundle-cart-drawer');drawer?.setAttribute('aria-busy','true');
 const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),15000);
 try{
  const response=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity}),signal:controller.signal});
  const cart=await response.json();if(!response.ok)throw new Error(cart.description||'Impossible de modifier la quantité.');
  input.dataset.fdActualQuantity=String(quantity);document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
 }catch(error){
  input.value=previous||'1';quantityNotice(error.name==='AbortError'?'La connexion est trop lente. Réessaie.':error.message,true);
  document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
 }finally{clearTimeout(timeout);quantityBusy=false;drawer?.removeAttribute('aria-busy');schedule();}
}

async function refresh(){
 if(busy){again=true;return;}
 const targets=[...document.querySelectorAll('.fd-moon-progress,[data-trio-progress]')];
 if(!targets.length)return;
 busy=true;
 try{
  const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});if(!response.ok)return;
  const cart=await response.json();syncQuantities(cart);

  // The full cart owns its own updates. In the drawer, count discounted split
  // lines together so one personalization cannot multiply on every refresh.
  if(!document.querySelector('[data-fdcc-form]')){
   const groups=new Map(),addons=new Map(),updates={};
   for(const item of cart.items){
    const group=item.properties?._fd_group;if(!group)continue;
    if(!addonHandles.has(item.handle)){groups.set(group,(groups.get(group)||0)+item.quantity);continue;}
    const id=group+'|'+String(item.variant_id||item.id||item.handle);
    if(!addons.has(id))addons.set(id,{group,lines:[],quantity:0});
    const extra=addons.get(id);extra.lines.push(item);extra.quantity+=item.quantity;
   }
   for(const extra of addons.values()){
    const quantity=groups.get(extra.group)||0;
    if(extra.quantity!==quantity)extra.lines.forEach((line,index)=>{updates[line.key]=index===0?quantity:0;});
   }
   if(Object.keys(updates).length){
    const sync=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});
    if(sync.ok){document.dispatchEvent(new CustomEvent('cart:refresh'));again=true;return;}
   }
  }

  let paidQty=0,giftQty=0,eligibleCount=0;
  cart.items.forEach((item,i)=>{
   if(eligible(item))eligibleCount+=item.quantity;
   const group=item.properties?._fd_group,extra=addonHandles.has(item.handle);
   const row=document.getElementById('CartDrawer-Item-'+i),details=row?.querySelector('.moonbundle-cart-item-details');
   if(row&&details){
    row.classList.toggle('fd-addon-line',extra&&!!group);
    if(extra){
     const picture=row.querySelector('.moonbundle-cart-item-image-container');if(picture)picture.dataset.fdAddon=item.handle==='flocage-personnalise'?'10':'+';
    }
    const parentIndex=group?cart.items.findIndex(x=>x.properties?._fd_group===group&&!addonHandles.has(x.handle)):-1;
    row.style.order=String((parentIndex>=0?parentIndex:i)*10+(extra?1:0));
    const text=['Flocage','Patch','Pour le maillot','Pour le article'].filter(k=>item.properties?.[k]).map(k=>k+' : '+item.properties[k]).join(' · ');
    let note=details.querySelector('.fd-line-personalization');
    if(text){if(!note){note=document.createElement('p');note.className='fd-line-personalization';note.style.cssText='font-size:9.5px;color:#8d6679;line-height:1.4;margin:5px 0;overflow-wrap:anywhere';details.append(note);}if(note.textContent!==text)note.textContent=text;}else note?.remove();
    syncGiftRow(row,details,item);
   }
   if(!eligible(item))return;
   if(giftInfo(item).isGift)giftQty+=item.quantity;else paidQty+=item.quantity;
  });

  renderProgress(targets,paidQty,giftQty);
  if(lastEligibleCount!==null&&eligibleCount>lastEligibleCount){
   document.getElementById('moonbundle-cart-drawer')?.classList.add('fdca-added');
   setTimeout(()=>document.getElementById('moonbundle-cart-drawer')?.classList.remove('fdca-added'),650);
  }
  lastEligibleCount=eligibleCount;
 }catch(_){}
 finally{busy=false;if(again){again=false;schedule();}}
}

document.addEventListener('input',e=>{if(e.target.matches(quantitySelector))e.target.dataset.fdQuantityDirty='1';},true);
document.addEventListener('change',e=>{if(!e.target.matches(quantitySelector))return;e.stopImmediatePropagation();commitQuantity(e.target);},true);
document.addEventListener('focusout',e=>{if(e.target.matches(quantitySelector)&&e.target.dataset.fdQuantityDirty)commitQuantity(e.target);},true);
document.addEventListener('keydown',e=>{if(e.key==='Enter'&&e.target.matches(quantitySelector)){e.preventDefault();e.stopImmediatePropagation();commitQuantity(e.target);e.target.blur();}},true);
document.addEventListener('click',e=>{if(quantityBusy&&e.target.closest('#moonbundle-cart-drawer .moonbundle-quantity-btn,#moonbundle-cart-drawer .moonbundle-cart-item-remove,#moonbundle-cart-drawer .moonbundle-cart-drawer-checkout')){e.preventDefault();e.stopImmediatePropagation();}},true);

function schedule(){clearTimeout(timer);timer=setTimeout(refresh,180);}
['fd:cart-added','cart:refresh','cart:updated','shopify:section:load'].forEach(name=>document.addEventListener(name,schedule));
const observer=new MutationObserver(records=>{if(records.some(r=>!r.target.closest?.('.fd-moon-progress,[data-trio-progress]')&&(r.target.closest?.('#moonbundle-cart-drawer')||[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('#moonbundle-cart-drawer,.fd-moon-progress')||n.querySelector?.('.fd-moon-progress'))))))schedule();});
function init(){observer.observe(document.body,{subtree:true,childList:true,characterData:true});schedule();}
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
})();
